import { IMainPhoto } from 'redhotpie-shared-lib/interfaces/IUser';
import * as utils from '../functions/utils';
import { IActor } from 'redhotpie-shared-lib/interfaces/INewFeed';
import Photo, { IPhotoData } from './photo';

const upcaseFirstCharacter = (tmp: string): string => tmp.charAt(0).toUpperCase() + tmp.substr(1);

export interface IActorData {
  UserID: number;
  Username?: string;
  MemberType: number | null;
  Location?: string;
  MemberTypeTitle?: string;
  ProfilePhoto?: IPhotoData;
  IsViewable?: boolean;
}

export default class Actor {
  userId: number | null;
  userName: string;
  memberType: number | null;
  mainPhoto: IMainPhoto;
  location: string;
  memberTypeTitle: string;
  isViewable: boolean | undefined;

  constructor() {
    this.userId = null;
    this.userName = '';
    this.memberType = null;
    this.mainPhoto = {};
    this.location = '';
    this.memberTypeTitle = '';
    this.isViewable = true;
  }

  static mappingPhoto(_obj: IPhotoData): IMainPhoto {
    const obj: IMainPhoto = {
      photoId: _obj.PhotoID,
      height: _obj.Height ? _obj.Height : 0,
      width: _obj.Width ? _obj.Width : 0,
      isUserImage: _obj.IsUserImage ? _obj.IsUserImage : false,
      isPublic: _obj.IsPublic ? _obj.IsPublic : false,
      classification: _obj.Classification || 1,
      thumbUrl: _obj.ThumbUrl ? _obj.ThumbUrl : '',
      fullUrl: _obj.FullUrl ? _obj.FullUrl : '',
      imageType: _obj.ImageType ? _obj.ImageType : '',
      showSafeMode: _obj.ShowSafeMode ? _obj.ShowSafeMode : false,
    };
    return obj;
  }

  static mappingObject(_actor: IActorData): IActor {
    let actor = Object.assign(new Actor(), _actor);
    actor.userId = _actor.UserID;
    actor.userName = _actor.Username ? upcaseFirstCharacter(_actor.Username) : '';
    actor.memberType = _actor.MemberType;
    actor.location = _actor.Location ? _actor.Location : '';
    actor.memberTypeTitle = _actor.MemberTypeTitle ? _actor.MemberTypeTitle : '';
    actor.mainPhoto = _actor.ProfilePhoto ? Photo.mappingObject(_actor.ProfilePhoto) : {};
    actor.isViewable = utils.hasOwnProperty(_actor, 'IsViewable') ? _actor.IsViewable : true;
    actor = utils.cleanObjectKeys(Object.keys(new Actor()), actor);
    return actor as IActor;
  }

  static mappingObjects(_actors: IActorData[]): IActor[] {
    return _actors.map(actor => Actor.mappingObject(actor));
  }
}
